export const SET_HRMS27U_INDEX_DISP = 'SET_HRMS27U_INDEX_DISP'
export const GET_HRMS27U_INDEX_DISP = 'GET_HRMS27U_INDEX_DISP'
export const SET_HRMS27U_INDEX_ADD_INLINE = 'SET_HRMS27U_INDEX_ADD_INLINE'
export const RECEIVED_HRMS27U_INDEX_ADD_INLINE = 'RECEIVED_HRMS27U_INDEX_ADD_INLINE'
export const SET_HRMS27U_COLUMNS = 'SET_HRMS27U_COLUMNS'
export const GET_HRMS27U_COLUMNS = 'GET_HRMS27U_COLUMNS'
export const SET_HRMS27U_LABELS = 'SET_HRMS27U_LABELS'
export const GET_HRMS27U_LABELS = 'GET_HRMS27U_LABELS'
export const RECEIVED_HRMS27U_COLUMNS_LABELS = 'RECEIVED_HRMS27U_COLUMNS_LABELS'
export const SET_HRMS27U_INDEX = 'SET_HRMS27U_INDEX'
export const GET_HRMS27U_INDEX = 'GET_HRMS27U_INDEX'
export const RECEIVED_HRMS27U_INDEX = 'RECEIVED_HRMS27U_INDEX'
export const SET_HRMS27U_INDEX_SELECTED = 'SET_HRMS27U_INDEX_SELECTED'
export const GET_HRMS27U_INDEX_SELECTED = 'GET_HRMS27U_INDEX_SELECTED'
export const SET_HRMS27U_INDEX_INLINE_DATA = 'SET_HRMS27U_INDEX_INLINE_DATA'
export const GET_HRMS27U_INDEX_INLINE_DATA = 'GET_HRMS27U_INDEX_INLINE_DATA'
export const TOGGLE_HRMS27U_PAGE = 'TOGGLE_HRMS27U_PAGE'
export const POST_HRMS27U_SEND_APPROVE = 'POST_HRMS27U_SEND_APPROVE'
export const POST_HRMS27U_INDEX_SAVE = 'POST_HRMS27U_INDEX_SAVE'



// WEBPACK FOOTER //
// ./src/store/modules/hrms27u/mutation-types.js